<template>
  <header>
    <h1 class="title">TODO</h1>
    <toggleTheme @toggle-theme="$emit('toggle-theme')"></toggleTheme>
  </header>
</template>

<script>
import toggleTheme from "./TheToggleButton.vue";

export default {
  name: 'TheHeader',
  components: { toggleTheme },
}

</script>

<style>
  
header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: max(100px, 14.794520547945206vh);
  height: calc(var(--bg-img-width) / 2);
  width: clamp(200px, var(--main-width), 540px);
  /* background-color: rgba(255, 255, 255, 0.1); */
  letter-spacing: 1rem;
  isolation: isolate;
}

.title { /* fluid typography and padding*/
  color: var(--title-clr);
  font-weight: 700;
  user-select: text;
}

</style>
